import { CustomModal } from "@/components/Modal";
import { PageTitle } from "@/components/Title";
import { AcquireBookFormUI } from "@/components/AcquireBook/AcquireBookFormUI";
import type { ISingleBookAcquireDialogData } from "@/types/singleBookAcquireDialog";
import { useReadOnlyUser } from "@/hooks/useReadOnlyUser";
import Stack from "@mui/material/Stack";

interface IProps {
  acquireBookOpen: boolean;
  handleClose: () => void;
  row: ISingleBookAcquireDialogData;
}

export const AcquireBookModal: React.FC<IProps> = (props: IProps) => {
  const { acquireBookOpen, handleClose, row } = props;
  const isReadOnly = useReadOnlyUser();
  return (
    <CustomModal
      isOpen={acquireBookOpen}
      handleClose={(
        _: Record<string, unknown>,
        reason: "backdropClick" | "escapeKeyDown"
      ): void => {
        if (
          reason &&
          (reason === "backdropClick" || reason === "escapeKeyDown")
        ) {
          return;
        }
        handleClose();
      }}
      width="70%"
      ariaLabelledby="acquire-books-modal"
      ariaDescribedby="acquire-books-modal-description"
      maxHeight="80vh"
      overflow="auto"
    >
      <Stack direction={"column"} spacing={3}>
        {/* タイトル */}
        <PageTitle>登記および図面取得</PageTitle>

        {/* 選択したモニタリング詳細の情報表示部分 */}
        <AcquireBookFormUI
          mode={"modal"}
          singleBookAcquireDialogData={row}
          isReadOnly={isReadOnly}
          handleClose={handleClose}
        />
      </Stack>
    </CustomModal>
  );
};
